export default {
  props: ['beforeIconType', 'afterIconType', 'leftSpan', 'rightSpan'],
  computed: {
    assignedBeforeIcon() {
      let assigned = this.beforeIconType !== undefined;
      return assigned;
    },
    assignedAfterIcon() {
      let assigned = this.afterIconType !== undefined;
      return assigned;
    },
    beforeIconStyles() {
      let styles = [];
      if (this.leftSpan !== undefined || this.leftSpan !== '') {
        let span = /^\d*\.?\d*(px|vh|vw|vmin)$/.test(this.leftSpan)
          ? this.leftSpan
          : this.leftSpan + 'px';
        let styleKey = '';
        this.$store.getters.isRtlDirection
          ? (styleKey = 'right')
          : (styleKey = 'left');
        styles.push({
          [styleKey]: span,
        });
      }
      return styles;
    },
    afterIconStyles() {
      let styles = [];
      if (this.rightSpan !== undefined || this.rightSpan !== '') {
        let span = /^\d*px|vh|vw|vmin$/.test(this.rightSpan)
          ? this.rightSpan
          : this.rightSpan + 'px';
        let styleKey = '';
        this.$store.getters.isRtlDirection
          ? (styleKey = 'left')
          : (styleKey = 'right');
        styles.push({
          [styleKey]: span,
        });
      }
      return styles;
    },
  },
};
